import GoogleLoginButton from '../google/GoogleLogin'
import MicrosoftLoginButton from '../microsoft/MicrosoftLogin'

import './styles.scss'

type Props = {
  size?: 'sm' | 'lg'
  /** Side-by-side on desktop; stacked on mobile (hero). */
  layout?: 'stack' | 'hero'
  className?: string
  googleHref?: string
  microsoftHref?: string
  onGoogleSignIn?: () => void
  onMicrosoftSignIn?: () => void
}

const OAuthSignInButtons = ({
  size = 'lg',
  layout = 'stack',
  className,
  googleHref,
  microsoftHref,
  onGoogleSignIn,
  onMicrosoftSignIn,
}: Props) => {
  const classes = [
    'oauth-sign-in-buttons',
    size === 'sm' ? 'oauth-sign-in-buttons--sm' : '',
    layout === 'hero' ? 'oauth-sign-in-buttons--hero' : '',
    className,
  ].filter(Boolean).join(' ')

  const googleButton = googleHref ? (
    <GoogleLoginButton size={size} href={googleHref} />
  ) : (
    <GoogleLoginButton size={size} onClick={onGoogleSignIn} />
  )

  const microsoftButton = microsoftHref ? (
    <MicrosoftLoginButton size={size} href={microsoftHref} />
  ) : (
    <MicrosoftLoginButton size={size} onClick={onMicrosoftSignIn} />
  )

  return (
    <div className={classes}>
      {googleButton}
      {microsoftButton}
    </div>
  )
}

export default OAuthSignInButtons
